/**
 * Определение «своего» подключения Kraken для строки очереди чекера:
 * совпадение host / domain_host / server_ip строки с URL подключения или IP модема из API.
 */

/** Подпись для прокси, распознанных как наши (инфраструктура LTE Center). */
export const PROXY_CHECKER_OWN_SUPPLIER_LABEL = 'LTE Center';

const normalizeAddrToken = (raw) => {
  if (raw == null) return '';
  const s = String(raw).trim();
  if (!s || s === '—' || s === '-') return '';
  return s.toLowerCase();
};

/** Извлекает hostname из server_url подключения (IP или домен), без порта. */
export const parseKrakenServerUrlHost = (serverUrl) => {
  if (!serverUrl || typeof serverUrl !== 'string') return '';
  const trimmed = serverUrl.trim();
  if (!trimmed) return '';
  let asUrl = trimmed;
  if (!/^[a-z][a-z0-9+.-]*:\/\//i.test(asUrl)) {
    asUrl = `http://${asUrl}`;
  }
  try {
    const u = new URL(asUrl);
    if (u.hostname) return u.hostname.toLowerCase();
  } catch {
    /* fall through */
  }
  const tail = trimmed.split('@').pop();
  const first = tail.split('/')[0];
  const hostPart = first.split(':')[0];
  return hostPart ? hostPart.trim().toLowerCase() : '';
};

const collectRowAddrTokens = (row) => {
  const tokens = new Set();
  const add = (v) => {
    const n = normalizeAddrToken(v);
    if (n) tokens.add(n);
  };
  if (!row || typeof row !== 'object') return tokens;
  add(row.host);
  add(row.domain_host);
  add(row.server_ip);
  return tokens;
};

/**
 * @param {object} row — строка очереди чекера
 * @param {object[]} connections — ответ getProxyCheckerKrakenConnections (data)
 * @param {object[]} servers — ответ getProxyCheckerKrakenServers (data)
 * @returns {string} «LTE Center» для своих прокси, иначе «Чужой»
 */
export const resolveProxyCheckerSupplierLabel = (row, connections, servers) => {
  const tokens = collectRowAddrTokens(row);
  if (tokens.size === 0) return 'Чужой';

  const conns = Array.isArray(connections) ? connections : [];
  for (const c of conns) {
    const h = parseKrakenServerUrlHost(c.server_url);
    if (h && tokens.has(h)) {
      return PROXY_CHECKER_OWN_SUPPLIER_LABEL;
    }
  }

  const srvs = Array.isArray(servers) ? servers : [];
  for (const s of srvs) {
    const ip = normalizeAddrToken(s.ip_address);
    if (ip && tokens.has(ip)) {
      return PROXY_CHECKER_OWN_SUPPLIER_LABEL;
    }
  }

  return 'Чужой';
};
